export default __webpack_public_path__ + "maps-examples-runtime-animate-line-thumbnail-480-dfb4788a17da97a2add973e97fa6518d.png";